/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import SupportComponent from './main';
import EditSupportComponent from './edit/main';
import NewSupportComponent from './new/main';

export const support = (context, next) => {
    context.primary = <SupportComponent />;
    next();
};

export const editSupport = (context, next) => {
    context.primary = <EditSupportComponent />;
    next();
};

export const newSupport = (context, next) => {
    context.primary = <NewSupportComponent />;
    next();
};